import React from "react";

const THEME = {
  primary: "#FB565F",
  primaryLight: "#fecdd3",
  primaryDark: "#e0454e",
  success: "#10b981",
  successLight: "#d1fae5",
  warning: "#f59e0b",
  warningLight: "#fef3c7",
  danger: "#dc2626",
  dangerLight: "#fee2e2",
  info: "#3b82f6",
  infoLight: "#dbeafe",
  purple: "#8b5cf6",
  purpleLight: "#ede9fe",
};

const IconUsers = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
    <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
  </svg>
);
const IconUserSingle = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
  </svg>
);
const IconCrown = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
    <path d="M5 2a1 1 0 011 1v1h8V3a1 1 0 112 0v1.586l.293.293a1 1 0 011.414 0l.707.707a1 1 0 010 1.414l-.293.293V17a2 2 0 01-2 2H5a2 2 0 01-2-2V7.414l-.293-.293a1 1 0 010-1.414l.707-.707a1 1 0 011.414 0l.293.293V3a1 1 0 011-1zm0 4.586l-.293.293a1 1 0 01-1.414 0l-.707-.707a1 1 0 010-1.414l.293-.293h10l.293.293a1 1 0 010 1.414l-.707.707a1 1 0 01-1.414 0L15 6.586V17H5V6.586z" />
  </svg>
);
const IconProposal = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
    <path d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z" />
    <path d="M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z" />
  </svg>
);
const IconCheck = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
  </svg>
);
const IconX = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
  </svg>
);
const IconClock = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
  </svg>
);
const IconCreditCard = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
    <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
    <path fillRule="evenodd" d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z" clipRule="evenodd" />
  </svg>
);
const IconChart = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
    <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
  </svg>
);

const iconMap = {
  users: IconUsers,
  user: IconUserSingle,
  crown: IconCrown,
  proposal: IconProposal,
  check: IconCheck,
  x: IconX,
  clock: IconClock,
  creditCard: IconCreditCard,
  chart: IconChart,
};

const StatCard = ({
  label,
  value,
  onClick,
  gradientFrom,
  gradientTo,
  iconBg,
  borderColor,
  icon = "chart",
}) => {
  const IconComponent = iconMap[icon] || iconMap.chart;
  return (
    <div
      onClick={onClick}
      className={`relative overflow-hidden rounded-2xl border-2 p-4 sm:p-5 transition-all duration-200 hover:shadow-xl hover:scale-[1.02] ${
        onClick ? "cursor-pointer" : ""
      }`}
      style={{
        borderColor: borderColor || THEME.primaryLight,
        background: `linear-gradient(135deg, #ffffff 0%, ${gradientFrom || THEME.primaryLight}15 100%)`,
      }}>
      <div className="relative z-10">
        <div
          className="inline-flex items-center justify-center w-10 h-10 rounded-xl mb-3"
          style={{ backgroundColor: iconBg || THEME.primaryLight }}>
          <span style={{ color: gradientTo || THEME.primary }}>
            <IconComponent />
          </span>
        </div>
        <p className="text-xs sm:text-sm font-semibold text-gray-600 uppercase tracking-wide">
          {label}
        </p>
        <p className="text-2xl sm:text-3xl lg:text-4xl font-extrabold mt-1 text-gray-900">
          {value ?? 0}
        </p>
      </div>
      <div
        className="absolute bottom-0 right-0 w-24 h-24 rounded-full opacity-20 -mr-8 -mb-8"
        style={{ backgroundColor: gradientTo || THEME.primary }}
      />
    </div>
  );
};

export default function DashboardOverviewCards({
  usersAnalytics,
  proposalsAnalytics,
  premiumCount,
  subscriptionStats,
  onTodayUsersClick,
  onMonthUsersClick,
  userStatsOnly = false,
}) {
  return (
    <div className="mb-6 lg:mb-8">
      <h1 className="font-main text-xl sm:text-2xl font-bold text-gray-900 mb-4">
        Overview
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
        <StatCard
          label="Today Users"
          value={usersAnalytics?.today}
          onClick={onTodayUsersClick}
          gradientFrom={THEME.infoLight}
          gradientTo={THEME.info}
          iconBg={THEME.infoLight}
          borderColor="#bfdbfe"
          icon="users"
        />
        <StatCard
          label="Monthly Users"
          value={usersAnalytics?.month}
          onClick={onMonthUsersClick}
          gradientFrom={THEME.primaryLight}
          gradientTo={THEME.primary}
          iconBg={THEME.primaryLight}
          borderColor="#fecdd3"
          icon="users"
        />
        <StatCard
          label="Total Users"
          value={usersAnalytics?.total}
          gradientFrom={THEME.purpleLight}
          gradientTo={THEME.purple}
          iconBg={THEME.purpleLight}
          borderColor="#ddd6fe"
          icon="user"
        />
        <StatCard
          label="Premium Users (Active)"
          value={premiumCount}
          gradientFrom={THEME.successLight}
          gradientTo={THEME.success}
          iconBg={THEME.successLight}
          borderColor="#a7f3d0"
          icon="crown"
        />
      </div>

      {!userStatsOnly && subscriptionStats != null && (
        <>
          <h2 className="font-main text-lg sm:text-xl font-bold text-gray-900 mt-6 mb-3">
            Subscription Stats
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 lg:gap-5">
            <StatCard
              label="Active Subscriptions"
              value={subscriptionStats.active}
              gradientFrom={THEME.successLight}
              gradientTo={THEME.success}
              iconBg={THEME.successLight}
              borderColor="#a7f3d0"
              icon="check"
            />
            <StatCard
              label="Expired Subscriptions"
              value={subscriptionStats.expired}
              gradientFrom={THEME.warningLight}
              gradientTo={THEME.warning}
              iconBg={THEME.warningLight}
              borderColor="#fde68a"
              icon="clock"
            />
            <StatCard
              label="Canceled Subscriptions"
              value={subscriptionStats.canceled}
              gradientFrom={THEME.dangerLight}
              gradientTo={THEME.danger}
              iconBg={THEME.dangerLight}
              borderColor="#fecaca"
              icon="x"
            />
          </div>
        </>
      )}

      {!userStatsOnly && proposalsAnalytics && (
        <>
      <h2 className="font-main text-lg sm:text-xl font-bold text-gray-900 mt-6 mb-3">
        Proposals & Connections
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
        <StatCard
          label="Total Proposals"
          value={proposalsAnalytics?.total_proposals}
          gradientFrom="#f3f4f6"
          gradientTo="#6b7280"
          iconBg="#e5e7eb"
          borderColor="#e5e7eb"
          icon="proposal"
        />
        <StatCard
          label="Accepted"
          value={proposalsAnalytics?.total_accepted_proposals}
          gradientFrom={THEME.successLight}
          gradientTo={THEME.success}
          iconBg={THEME.successLight}
          borderColor="#a7f3d0"
          icon="check"
        />
        <StatCard
          label="Rejected"
          value={proposalsAnalytics?.total_rejected_proposals}
          gradientFrom={THEME.dangerLight}
          gradientTo={THEME.danger}
          iconBg={THEME.dangerLight}
          borderColor="#fecaca"
          icon="x"
        />
        <StatCard
          label="Pending"
          value={proposalsAnalytics?.total_pending_proposals}
          gradientFrom={THEME.warningLight}
          gradientTo={THEME.warning}
          iconBg={THEME.warningLight}
          borderColor="#fde68a"
          icon="clock"
        />
      </div>
        </>
      )}
    </div>
  );
}
